/* @ngInject */

export default (BILLING) => {
  /*
   * Constructor
   * --------------------------------------------------------------------------------
   */
  function Plan(id, shorthand, name, type, interval, value, total, features) {
    this.id = id;
    this.shorthand = shorthand;
    this.name = name;
    this.type = type;
    this.interval = interval;
    this.value = value;
    this.total = total;
    this.features = features;
  }

  /*
   * Static Methods
   * --------------------------------------------------------------------------------
   */
  Plan.blank = function () {
    return Plan.build({
      id: '',
      shorthand: '',
      name: '',
      type: '',
      interval: '',
      value: 0,
      total: 0,
      features: {}
    });
  };
  Plan.build = function (data) {
    return new Plan(
      data.id,
      data.shorthand,
      data.name,
      data.type,
      data.interval,
      data.value,
      data.total,
      data.features
    );
  };

  Plan.prototype.getName = function () {
    return this.name;
  };
  Plan.prototype.getValue = function (quantity) {
    return this.value * (quantity || quantity === 0 ? quantity : 1);
  };
  Plan.prototype.getTotal = function (quantity) {
    return this.total * (quantity || quantity === 0 ? quantity : 1);
  };
  Plan.prototype.getTotalWithTax = function (quantity) {
    if (this.type === 'Annual') {
      return (
        this.getTotal(quantity) *
        ((100 + BILLING.BILLING_DETAILS.TAX) / 100)
      ).formatWithCurrency('$', 2);
    }
    return (
      this.getValue(quantity) *
      ((100 + BILLING.BILLING_DETAILS.TAX) / 100)
    ).formatWithCurrency('$', 2);
  };
  Plan.prototype.getTotalWithTaxWithoutFormated = function (quantity) {
    if (this.type === 'Annual') {
      return this.getTotal(quantity) * ((100 + BILLING.BILLING_DETAILS.TAX) / 100);
    }
    return this.getValue(quantity) * ((100 + BILLING.BILLING_DETAILS.TAX) / 100);
  };
  Plan.prototype.getValueInCents = function (quantity) {
    return this.getValue(quantity) * 100;
  };

  return Plan;
};
